/**
 * @generated SignedSource<<90dd0351eee639d2e8a88ceb9ae14938>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PortfolioPeriod = "DAY" | "MAX" | "MONTH" | "SIX_MONTHS" | "WEEK" | "YEAR";
export type PortfolioAssetGroupsQuery$variables = {
  expandGroups: boolean;
  period: PortfolioPeriod;
};
export type PortfolioAssetGroupsQuery$data = {
  readonly portfolio: {
    readonly assetGroups: {
      readonly edges: ReadonlyArray<{
        readonly fiatBalance: PrecisionFloat;
        readonly name: string;
        readonly node?: ReadonlyArray<{
          readonly edges: ReadonlyArray<{
            readonly assetBalance: PrecisionFloat | null | undefined;
            readonly fiatBalance: PrecisionFloat | null | undefined;
            readonly node: {
              readonly __typename: string;
              readonly id: string;
              readonly logoUrl: string | null | undefined;
              readonly name: string | null | undefined;
              readonly price: PrecisionFloat | null | undefined;
              readonly symbol: string | null | undefined;
            } | null | undefined;
            readonly totalReturn: ValueChange | null | undefined;
          } | null | undefined> | null | undefined;
          readonly totalCount: number | null | undefined;
        }> | null | undefined;
        readonly order: number | null | undefined;
        readonly totalAssets: number | null | undefined;
        readonly totalReturn: ValueChange;
      }> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type PortfolioAssetGroupsQuery = {
  response: PortfolioAssetGroupsQuery$data;
  variables: PortfolioAssetGroupsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "expandGroups"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "period"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalReturn",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fiatBalance",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "period",
            "variableName": "period"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Portfolio",
    "kind": "LinkedField",
    "name": "portfolio",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PortfolioAssetGroupsConnection",
        "kind": "LinkedField",
        "name": "assetGroups",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PortfolioAssetGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "order",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalAssets",
                "storageKey": null
              },
              {
                "condition": "expandGroups",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PortfolioAssetsConnection",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PortfolioAssetsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "assetBalance",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__typename",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "id",
                                "storageKey": null
                              },
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "symbol",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "logoUrl",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "price",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PortfolioAssetGroupsQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PortfolioAssetGroupsQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "746096628b539ea8373f71a875d2f8b2",
    "id": null,
    "metadata": {},
    "name": "PortfolioAssetGroupsQuery",
    "operationKind": "query",
    "text": "query PortfolioAssetGroupsQuery(\n  $period: PortfolioPeriod!\n  $expandGroups: Boolean!\n) {\n  portfolio(input: {period: $period}) {\n    assetGroups {\n      edges {\n        name\n        order\n        totalReturn\n        fiatBalance\n        totalAssets\n        node @include(if: $expandGroups) {\n          totalCount\n          edges {\n            totalReturn\n            fiatBalance\n            assetBalance\n            node {\n              __typename\n              id\n              name\n              symbol\n              logoUrl\n              price\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0a30bd7b04594dfb49fd8c467ee7afc4";

export default node;
